import React from "react";
import { Menu } from "./Menu";

const Menus = (props) => {
  const menus = props.menus;
  return (
    <div className="row">
      <div className="">
          <h4 className="card-title">Menu</h4>
          <ul className="list-group bg-transparent ms-4">
            {menus.map((menu) => (
                <Menu menu={menu} />
            ))}{" "}
          </ul>
      </div>

    </div>
  );
};

export default Menus;
